import { FC } from 'react';
import MinkaDetail from './MinkaDetail';
import UseMinkaDetail from './UseMinkaDetail';

const MinkaDetailContainer: FC = () => {
  return <MinkaDetail {...UseMinkaDetail()} />;
};

export default MinkaDetailContainer;
